import { WHATSAPP } from '../../constants';
import './education.css';

const topics = [
  {
    product: 'Vinagre Concentrado',
    use: 'Disolver sarro, limpiar grifería, azulejos y eliminar olores. Diluí 1 parte de vinagre en 3 de agua para uso general.',
    caution: 'No usar sobre mármol ni superficies porosas. Evitar mezclar con lavandina.',
  },
  {
    product: 'Bicarbonato de Sodio',
    use: 'Desodorizar heladera, limpiar superficies, ablandar agua, desengrasar horno. Hacé pasta con agua para manchas difíciles.',
  },
  {
    product: 'Percarbonato de Sodio',
    use: 'Blanquear ropa blanca y sacar manchas. Agregá 1 cucharada al lavarropas junto con tu detergente habitual.',
    caution: 'Usar en ropa blanca. No apto para lana, seda ni colores delicados.',
  },
  {
    product: 'Magic Powder',
    use: 'Mezcla de percarbonato y bicarbonato. Sirve para ropa, superficies, baño y cocina. Usá 1 cucharada por carga de lavado.',
    caution: 'Contiene percarbonato: no usar en lana, seda o colores muy sensibles.',
  },
  {
    product: 'Ácido Cítrico',
    use: 'Antical potente para lavavajillas, cafeteras, pava eléctrica y grifería. Disolvé en agua caliente y dejá actuar.',
    caution: 'No mezclar con lavandina ni productos clorados. Usar guantes si se usa concentrado.',
  },
  {
    product: 'Bórax',
    use: 'Limpieza de pisos, paredes, manchas de ropa y desinfección. Disolvé 1 cda en agua tibia para limpieza general.',
    caution: 'Mantener fuera del alcance de niños. No ingerir.',
  },
  {
    product: 'Tierra de Diatomeas',
    use: 'Control de hormigas, pulgas, cucarachas y otros insectos. Espolvoreá en zonas de paso o grietas.',
    caution: 'Usar barbijo al aplicar para no inhalar el polvo fino.',
  },
];

function Education() {
  return (
    <section className="section education">
      <div className="container">
        <div className="education__header">
          <span className="section-label">Aprendé a usarlos</span>
          <h2 className="section-title">Cada producto tiene su modo de uso</h2>
          <p className="section-subtitle">No es complicado. Te contamos lo esencial para que aproveches cada producto al máximo.</p>
        </div>
        <div className="education__grid">
          {topics.map((t) => (
            <details key={t.product} className="education__item card">
              <summary className="education__summary">
                <span>Cómo usar {t.product}</span>
                <span className="education__plus">+</span>
              </summary>
              <div className="education__body">
                <p><strong>Uso principal:</strong> {t.use}</p>
                {t.caution && <p className="education__caution"><strong>Precaución:</strong> {t.caution}</p>}
                <a
                  href={WHATSAPP.education(t.product)}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-whatsapp btn-sm"
                  style={{ marginTop: 12 }}
                >
                  Consultar modo de uso
                </a>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Education;
